<template>
    <el-dialog :title="titleDialog" :visible="showDialog" :close-on-click-modal="true" @close="close" @open="create"
        append-to-body top="7vh" width="55%" custom-class="pos-presentation-price-dialog">
        <form ref="priceForm" autocomplete="off" tabindex="0" @submit.prevent
            @keydown.stop.prevent.left="moveHorizontal(-1)" @keydown.stop.prevent.right="moveHorizontal(1)"
            @keydown.stop.prevent.up="moveVertical(-1)" @keydown.stop.prevent.down="moveVertical(1)"
            @keydown.enter.stop.prevent @keyup.enter.stop.prevent="confirmKeyboardSelection"
            @keydown.stop.prevent.esc="close">
            <div class="form-body">

                <!--
                    CONFIGURACIÓN DESACTIVADA:
                    selector tradicional con un precio por presentación.
                -->
                <div v-if="!canSelectPresentationPrices">
                    <el-select ref="ref_select_price" v-model="selected_price" placeholder="Seleccionar presentación"
                        style="width: 100%" @keyup.enter.native.stop.prevent="enterSelectPrice">
                        <el-option v-for="option in selectableOptions" :key="option._selector_id"
                            :label="getDescription(option)" :value="option._selector_id" />
                    </el-select>
                </div>

                <!--
                    CONFIGURACIÓN ACTIVADA:
                    precio unitario + tabla de presentaciones.
                -->
                <div v-else>
                    <div class="mb-3">
                        <div class="price-section-title">
                            Precio unitario
                        </div>

                        <button v-if="basePriceOption" type="button" class="base-price-option" :class="{
                            selected: isOptionSelected(
                                basePriceOption
                            )
                        }" @click="selectOption(basePriceOption)">
                            <span>
                                Precio unitario
                            </span>

                            <strong>
                                S/ {{ formatPrice(
                                    basePriceOption.applied_price
                                ) }}
                            </strong>

                            <span class="unit-description">
                                {{ getUnitTypeDescription(
                                    basePriceOption
                                ) }}
                            </span>

                            <i v-if="isOptionSelected(basePriceOption)" class="fa fa-check-circle"></i>
                        </button>
                    </div>

                    <div class="price-section-title">
                        Presentaciones
                    </div>

                    <div class="table-responsive">
                        <table class="table table-bordered presentation-price-table">
                            <thead>
                                <tr>
                                    <th>Presentación</th>
                                    <th>Unidad</th>
                                    <th>Precio 1</th>
                                    <th>Precio 2</th>
                                    <th>Precio 3</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="presentation in presentationRows" :key="presentation.id">
                                    <td>
                                        <strong>
                                            {{ presentation.description }}
                                        </strong>
                                    </td>

                                    <td>
                                        {{ getUnitTypeDescription(
                                            presentation
                                        ) }}
                                    </td>

                                    <td v-for="priceIndex in [1, 2, 3]" :key="`${presentation.id}-${priceIndex}`
                                        ">
                                        <button type="button" class="presentation-price-button" :class="{
                                            selected:
                                                isPresentationPriceSelected(
                                                    presentation,
                                                    priceIndex
                                                ),
                                            default:
                                                isDefaultPrice(
                                                    presentation,
                                                    priceIndex
                                                )
                                        }" :disabled="!isPriceAvailable(
                                            presentation,
                                            priceIndex
                                        )
                                            " @click="
                                                selectPresentationPrice(
                                                    presentation,
                                                    priceIndex
                                                )
                                                ">
                                            <template v-if="
                                                isPriceAvailable(
                                                    presentation,
                                                    priceIndex
                                                )
                                            ">
                                                <span>
                                                    S/ {{ formatPrice(
                                                        getPrice(
                                                            presentation,
                                                            priceIndex
                                                        )
                                                    ) }}
                                                </span>

                                                <small v-if="
                                                    isDefaultPrice(
                                                        presentation,
                                                        priceIndex
                                                    )
                                                " class="default-label">
                                                    Predeterminado
                                                </small>

                                                <i v-if="
                                                    isPresentationPriceSelected(
                                                        presentation,
                                                        priceIndex
                                                    )
                                                " class="fa fa-check-circle"></i>
                                            </template>

                                            <template v-else>
                                                —
                                            </template>
                                        </button>
                                    </td>
                                </tr>

                                <tr v-if="presentationRows.length === 0">
                                    <td colspan="5" class="text-center text-muted">
                                        Este producto no tiene presentaciones
                                        configuradas.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="form-actions text-right mt-4">
                <el-button type="primary" :disabled="!selected_price" @click.prevent="enterSelectPrice">
                    <i class="fa fa-check mr-1"></i>
                    Seleccionar
                </el-button>

                <el-button @click.prevent="close">
                    Cerrar
                </el-button>
            </div>
        </form>
    </el-dialog>
</template>
<script>

export default {
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },

        itemUnitTypes: {
            type: Array,
            default: () => [],
        },

        allowSelectPresentationPrices: {
            default: false,
        },
    },
    data() {
        return {
            selected_price: null,
            titleDialog: 'Seleccionar precio',
            keyboard_row: 0,
            keyboard_column: 0,
        }
    },
    computed: {
        canSelectPresentationPrices() {
            const value =
                this.allowSelectPresentationPrices;

            return (
                value === true ||
                value === 1 ||
                value === "1"
            );
        },

        selectableOptions() {
            const options = [];

            this.itemUnitTypes.forEach((option) => {
                /*
                 * El precio unitario principal siempre aparece
                 * una sola vez y en la primera posición.
                 */
                if (option.is_base_price) {
                    options.push({
                        ...option,
                        _selector_id: `base-${option.id}`,
                    });

                    return;
                }

                /*
                 * Configuración desactivada:
                 * solo mostramos el precio predeterminado.
                 */
                if (!this.canSelectPresentationPrices) {
                    options.push({
                        ...option,
                        _selector_id:
                            `presentation-${option.id}`,
                    });

                    return;
                }

                /*
                 * Configuración activada:
                 * convertimos Precio 1, Precio 2 y Precio 3
                 * en alternativas independientes.
                 */
                [1, 2, 3].forEach((priceIndex) => {
                    const price = Number(
                        option[`price${priceIndex}`] || 0
                    );

                    /*
                     * Los precios en cero no se muestran.
                     */
                    if (price <= 0) {
                        return;
                    }

                    options.push({
                        ...option,

                        /*
                         * Identificador exclusivo para el select.
                         * No reemplaza el id real de la presentación.
                         */
                        _selector_id:
                            `presentation-${option.id}-price-${priceIndex}`,

                        original_price_default:
                            Number(option.price_default),

                        selected_price: priceIndex,

                        /*
                         * setPriceItem() ya utiliza price_default,
                         * por eso colocamos aquí el precio escogido.
                         */
                        price_default: priceIndex,

                        applied_price: price,
                    });
                });
            });

            return options;
        },

        basePriceOption() {
            return this.selectableOptions.find(
                option => option.is_base_price
            ) || null;
        },

        presentationRows() {
            return this.itemUnitTypes.filter(
                option => !option.is_base_price
            );
        },
    },
    async created() {

    },
    methods: {
        getPrice(presentation, priceIndex) {
            return Number(
                presentation[`price${priceIndex}`] || 0
            );
        },

        formatPrice(value) {
            return Number(value || 0).toFixed(4);
        },

        isPriceAvailable(presentation, priceIndex) {
            return this.getPrice(
                presentation,
                priceIndex
            ) > 0;
        },

        isDefaultPrice(presentation, priceIndex) {
            return (
                Number(presentation.price_default) ===
                Number(priceIndex)
            );
        },

        getPresentationPriceOption(
            presentation,
            priceIndex
        ) {
            const selectorId =
                `presentation-${presentation.id}-price-${priceIndex}`;

            return this.selectableOptions.find(
                option =>
                    option._selector_id === selectorId
            ) || null;
        },

        selectPresentationPrice(
            presentation,
            priceIndex
        ) {
            const option =
                this.getPresentationPriceOption(
                    presentation,
                    priceIndex
                );

            if (!option) {
                this.$message.warning(
                    "Este precio no está configurado"
                );

                return;
            }

            this.selected_price =
                option._selector_id;

            this.syncKeyboardPosition();
            this.focusModal();
        },

        selectOption(option) {
            if (!option) {
                return;
            }

            this.selected_price =
                option._selector_id;

            this.syncKeyboardPosition();
            this.focusModal();
        },

        isOptionSelected(option) {
            if (!option) {
                return false;
            }

            return (
                String(this.selected_price) ===
                String(option._selector_id)
            );
        },

        isPresentationPriceSelected(
            presentation,
            priceIndex
        ) {
            const option =
                this.getPresentationPriceOption(
                    presentation,
                    priceIndex
                );

            return this.isOptionSelected(option);
        },
        focusModal() {
            this.$nextTick(() => {
                const form = this.$refs.priceForm;

                if (form && typeof form.focus === "function") {
                    form.focus();
                }
            });
        },

        getFirstAvailablePriceIndex(presentation) {
            const defaultPriceIndex = Number(
                presentation.price_default || 2
            );

            if (
                this.isPriceAvailable(
                    presentation,
                    defaultPriceIndex
                )
            ) {
                return defaultPriceIndex;
            }

            return [1, 2, 3].find(
                priceIndex =>
                    this.isPriceAvailable(
                        presentation,
                        priceIndex
                    )
            ) || null;
        },

        getCurrentPresentationRow() {
            if (this.keyboard_row <= 0) {
                return null;
            }

            return this.presentationRows[
                this.keyboard_row - 1
            ] || null;
        },

        syncKeyboardPosition() {
            /*
             * Precio unitario seleccionado.
             */
            if (
                this.basePriceOption &&
                this.isOptionSelected(this.basePriceOption)
            ) {
                this.keyboard_row = 0;
                this.keyboard_column = 0;

                return;
            }

            /*
             * Busca la presentación y el precio actualmente marcados.
             */
            for (
                let rowIndex = 0;
                rowIndex < this.presentationRows.length;
                rowIndex++
            ) {
                const presentation =
                    this.presentationRows[rowIndex];

                for (
                    let priceIndex = 1;
                    priceIndex <= 3;
                    priceIndex++
                ) {
                    const option =
                        this.getPresentationPriceOption(
                            presentation,
                            priceIndex
                        );

                    if (this.isOptionSelected(option)) {
                        this.keyboard_row =
                            rowIndex + 1;

                        this.keyboard_column =
                            priceIndex - 1;

                        return;
                    }
                }
            }
        },

        selectKeyboardPosition() {
            /*
             * Fila superior: precio unitario.
             */
            if (this.keyboard_row === 0) {
                this.selectOption(
                    this.basePriceOption
                );

                return;
            }

            const presentation =
                this.getCurrentPresentationRow();

            if (!presentation) {
                return;
            }

            const requestedPriceIndex =
                this.keyboard_column + 1;

            if (
                this.isPriceAvailable(
                    presentation,
                    requestedPriceIndex
                )
            ) {
                this.selectPresentationPrice(
                    presentation,
                    requestedPriceIndex
                );

                return;
            }

            /*
             * Si la celda solicitada no tiene precio,
             * escoge el primer precio disponible de la fila.
             */
            const availablePriceIndex =
                this.getFirstAvailablePriceIndex(
                    presentation
                );

            if (availablePriceIndex) {
                this.keyboard_column =
                    availablePriceIndex - 1;

                this.selectPresentationPrice(
                    presentation,
                    availablePriceIndex
                );
            }
        },

        moveHorizontal(direction) {
            if (!this.canSelectPresentationPrices) {
                return;
            }

            /*
             * Desde precio unitario, flecha derecha
             * entra a la primera presentación.
             */
            if (this.keyboard_row === 0) {
                if (
                    direction > 0 &&
                    this.presentationRows.length > 0
                ) {
                    this.keyboard_row = 1;

                    const presentation =
                        this.getCurrentPresentationRow();

                    const availablePriceIndex =
                        this.getFirstAvailablePriceIndex(
                            presentation
                        );

                    if (availablePriceIndex) {
                        this.keyboard_column =
                            availablePriceIndex - 1;
                    }
                }

                this.selectKeyboardPosition();

                return;
            }

            const presentation =
                this.getCurrentPresentationRow();

            if (!presentation) {
                return;
            }

            let nextColumn =
                this.keyboard_column;

            /*
             * Busca la siguiente celda disponible.
             */
            for (let attempt = 0; attempt < 3; attempt++) {
                nextColumn += direction;

                if (nextColumn < 0) {
                    nextColumn = 2;
                }

                if (nextColumn > 2) {
                    nextColumn = 0;
                }

                if (
                    this.isPriceAvailable(
                        presentation,
                        nextColumn + 1
                    )
                ) {
                    this.keyboard_column =
                        nextColumn;

                    break;
                }
            }

            this.selectKeyboardPosition();
        },

        moveVertical(direction) {
            if (!this.canSelectPresentationPrices) {
                return;
            }

            const maximumRow =
                this.presentationRows.length;

            let nextRow =
                this.keyboard_row + direction;

            /*
             * Navegación circular.
             */
            if (nextRow < 0) {
                nextRow = maximumRow;
            }

            if (nextRow > maximumRow) {
                nextRow = 0;
            }

            this.keyboard_row = nextRow;

            /*
             * La fila cero corresponde al precio unitario.
             */
            if (this.keyboard_row === 0) {
                this.keyboard_column = 0;
                this.selectOption(
                    this.basePriceOption
                );

                return;
            }

            const presentation =
                this.getCurrentPresentationRow();

            /*
             * Intenta conservar la misma columna.
             */
            if (
                !this.isPriceAvailable(
                    presentation,
                    this.keyboard_column + 1
                )
            ) {
                const availablePriceIndex =
                    this.getFirstAvailablePriceIndex(
                        presentation
                    );

                if (availablePriceIndex) {
                    this.keyboard_column =
                        availablePriceIndex - 1;
                }
            }

            this.selectKeyboardPosition();
        },
        enterSelectPrice() {
            if (
                this.canSelectPresentationPrices &&
                !this.selected_price
            ) {
                this.selectKeyboardPosition();
            }

            const unitType = this.selectableOptions.find(
                option =>
                    String(option._selector_id) ===
                    String(this.selected_price)
            );

            if (!unitType) {
                this.$message.warning(
                    'Seleccione una presentación'
                );

                return;
            }

            /*
             * Primero cierra el listado interno del select.
             */
            this.closeSelectDropdown();

            /*
             * Después cierra el diálogo.
             */
            this.$emit(
                'update:showDialog',
                false
            );

            this.selected_price = null;

            /*
             * Finalmente comunica la presentación al POS.
             */
            this.$nextTick(() => {
                this.$eventHub.$emit(
                    'enterSelectItemUnitType',
                    unitType
                );
            });
        },
        getUnitTypeDescription(option) {
            return (
                option.unit_type_description ||
                (option.unit_type && option.unit_type.description) ||
                option.unit_type_id ||
                ""
            );
        },
        getDescription(option) {
            const unitTypeDescription =
                this.getUnitTypeDescription(option);

            if (option.is_base_price) {
                return `Precio unitario: ${Number(
                    option.applied_price || 0
                ).toFixed(4)} - ${unitTypeDescription}`;
            }

            const presentation = option.description
                ? option.description
                : "Presentación";

            /*
             * Cuando está permitido seleccionar precios,
             * indicamos claramente Precio 1, 2 o 3.
             */
            if (this.canSelectPresentationPrices) {
                const priceIndex = Number(
                    option.selected_price ||
                    option.price_default ||
                    2
                );

                const price = Number(
                    option.applied_price ||
                    option[`price${priceIndex}`] ||
                    0
                );

                return `${presentation} - Precio ${priceIndex}: ${price.toFixed(
                    4
                )} - ${unitTypeDescription}`;
            }

            /*
             * Configuración desactivada:
             * utilizamos únicamente el precio predeterminado.
             */
            const defaultPrice = Number(
                option.price_default || 2
            );

            const price = Number(
                option[`price${defaultPrice}`] || 0
            );

            return `${presentation}: ${price.toFixed(
                4
            )} - ${unitTypeDescription}`;
        },
        create() {
            let initialOption = null;

            /*
             * Cuando está activada la selección múltiple,
             * marcamos inicialmente el precio predeterminado
             * de la primera presentación.
             */
            if (
                this.canSelectPresentationPrices &&
                this.presentationRows.length > 0
            ) {
                const presentation =
                    this.presentationRows[0];

                const defaultPriceIndex =
                    Number(
                        presentation.price_default || 2
                    );

                initialOption =
                    this.getPresentationPriceOption(
                        presentation,
                        defaultPriceIndex
                    );
            }

            /*
             * Si la presentación no tiene disponible su precio
             * predeterminado, usamos la primera alternativa válida.
             */
            if (!initialOption) {
                initialOption =
                    this.selectableOptions[0] || null;
            }

            this.selected_price =
                initialOption
                    ? initialOption._selector_id
                    : null;

            this.$nextTick(() => {
                this.syncKeyboardPosition();

                if (this.canSelectPresentationPrices) {
                    this.focusModal();
                } else {
                    this.initFocus();
                }
            });
        },
        initFocus() {
            const select =
                this.$refs.ref_select_price;

            if (!select || !select.$el) {
                return;
            }

            const input =
                select.$el.querySelector('input');

            if (input) {
                input.focus();
            }
        },
        close() {
            this.closeSelectDropdown();

            this.selected_price = null;

            this.$emit(
                'update:showDialog',
                false
            );
        },
        closeSelectDropdown() {
            const select =
                this.$refs.ref_select_price;

            if (!select) {
                return;
            }

            select.visible = false;

            if (typeof select.handleClose === 'function') {
                select.handleClose();
            }

            if (typeof select.blur === 'function') {
                select.blur();
            }
        },
        confirmKeyboardSelection() {
            this.selectKeyboardPosition();

            this.$nextTick(() => {
                this.enterSelectPrice();
            });
        },
    }
}
</script>

<style scoped>
.price-section-title {
    margin-bottom: 8px;
    color: #606266;
    font-size: 13px;
    font-weight: 600;
}

.base-price-option {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 12px 15px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fff;
    color: #606266;
    cursor: pointer;
    gap: 12px;
    text-align: left;
    transition: all 0.2s ease;
}

.base-price-option:hover {
    border-color: #00bfa5;
}

.base-price-option strong {
    margin-left: auto;
    color: #303133;
}

.base-price-option.selected {
    border-color: #00bfa5;
    background: #e8f8f5;
    color: #008f7a;
}

.base-price-option.selected strong {
    color: #008f7a;
}

.base-price-option .fa-check-circle {
    color: #00bfa5;
}

.unit-description {
    color: #909399;
}

.presentation-price-table {
    margin-bottom: 0;
    background: #fff;
}

.presentation-price-table th {
    vertical-align: middle;
    background: #f5f7fa;
    color: #606266;
    font-size: 12px;
    text-align: center;
    white-space: nowrap;
}

.presentation-price-table td {
    vertical-align: middle;
}

.presentation-price-table td:first-child {
    min-width: 140px;
}

.presentation-price-button {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-width: 105px;
    min-height: 52px;
    padding: 7px 8px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fff;
    color: #606266;
    cursor: pointer;
    transition: all 0.2s ease;
}

.presentation-price-button:hover:not(:disabled) {
    border-color: #00bfa5;
    color: #008f7a;
}

.presentation-price-button.default {
    border-color: #67c23a;
}

.presentation-price-button.selected {
    border-color: #00bfa5;
    background: #00bfa5;
    color: #fff;
}

.presentation-price-button:disabled {
    background: #f5f7fa;
    color: #c0c4cc;
    cursor: not-allowed;
}

.default-label {
    display: block;
    margin-top: 3px;
    font-size: 9px;
}

.presentation-price-button.selected .default-label {
    color: #fff;
}

.presentation-price-button .fa-check-circle {
    position: absolute;
    top: 4px;
    right: 4px;
}

@media (max-width: 768px) {
    .table-responsive {
        overflow-x: auto;
    }

    .base-price-option {
        flex-wrap: wrap;
    }

    .base-price-option strong {
        margin-left: 0;
    }
}

.pos-presentation-price-dialog form:focus {
    outline: none;
}
</style>

<style>
@media (max-width: 768px) {
    .pos-presentation-price-dialog {
        width: 95% !important;
    }
}
</style>


// WEBPACK FOOTER //
// resources/js/views/tenant/pos/partials/item_unit_types.vue